import {
  GetMenuAPIRequest,
  GetMenusAPIRequest,
  UpdateMenuAPIRequest,
  UpdateMenuOperationsAPIRequest,
} from 'utils/constants/network';
import { callAPI } from 'utils/network';
import {
  GetOutOfStockAPIRequest,
  SearchMenuItemsAPIRequest,
  SetStockStatusAPIRequest,
} from '../../utils/constants/network';

export const REQUEST_MENU_LIST = 'REQUEST_MENU_LIST';
export const SET_MENU_LIST = 'SET_MENU_LIST';
export const REQUEST_MENU = 'REQUEST_MENU';
export const SET_MENU = 'SET_MENU';
export const REQUEST_UPDATE_MENU = 'REQUEST_UPDATE_MENU';
export const UPDATED_MENU = 'UPDATED_MENU';
export const REQUEST_UPDATE_MENU_OPERATIONS = 'REQUEST_UPDATE_MENU_OPERATIONS';
export const UPDATED_MENU_OPERATIONS = 'UPDATED_MENU_OPERATIONS';

export const REQUEST_SEARCH_MENU = 'REQUEST_SEARCH_MENU';
export const SET_MENU_SEARCH_RESULTS = 'SET_MENU_SEARCH_RESULTS';
export const REQUEST_OUT_OF_STOCK_ITEMS = 'REQUEST_OUT_OF_STOCK_ITEMS';
export const SET_OUT_OF_STOCK_ITEMS = 'SET_OUT_OF_STOCK_ITEMS';
export const REQUEST_SET_STOCK_STATUS = 'REQUEST_SET_STOCK_STATUS';
export const SET_STOCK_UPDATED = 'SET_STOCK_UPDATED';

const requestSearchMenu = () => ({
  type: REQUEST_SEARCH_MENU,
  payload: {
    searchingMenu: true,
  },
});

const setMenuSearchResults = results => ({
  type: SET_MENU_SEARCH_RESULTS,
  payload: {
    searchingMenu: false,
    menuSearchResults: results,
  },
});

const setMenuSearchResultsError = () => ({
  type: SET_MENU_SEARCH_RESULTS,
  payload: {
    searchingMenu: false,
  },
});

const requestOutOfStock = () => ({
  type: REQUEST_OUT_OF_STOCK_ITEMS,
  payload: {
    fetchingOutOfStock: true,
  },
});

const setOutOfStockItems = results => ({
  type: SET_OUT_OF_STOCK_ITEMS,
  payload: {
    fetchingOutOfStock: false,
    outOfStockItems: results,
  },
});

const setOutOfStockItemsError = () => ({
  type: SET_OUT_OF_STOCK_ITEMS,
  payload: {
    fetchingOutOfStock: false,
  },
});

const requestSetStockStatus = () => ({
  type: REQUEST_SET_STOCK_STATUS,
  payload: {
    updatingStockStatus: true,
  },
});

const setStockStatusUpdated = () => ({
  type: SET_STOCK_UPDATED,
  payload: {
    updatingStockStatus: false,
  },
});

const requestMenuList = () => ({
  type: REQUEST_MENU_LIST,
  payload: {
    fetchingMenuList: true,
    menuListFetched: false,
  },
});

export const setMenuList = (list, success) => ({
  type: SET_MENU_LIST,
  payload: {
    fetchingMenuList: false,
    menuListFetched: success,
    menuList: list,
  },
});

const requestUpdateMenu = () => ({
  type: REQUEST_UPDATE_MENU,
  payload: {
    updatingMenu: true,
    menuUpdated: false,
  },
});

const updatedMenuOperations = success => ({
  type: UPDATED_MENU_OPERATIONS,
  payload: {
    updatingMenu: false,
    menuUpdated: success,
  },
});

const requestUpdateMenuOperations = () => ({
  type: REQUEST_UPDATE_MENU_OPERATIONS,
  payload: {
    updatingMenu: true,
    menuUpdated: false,
  },
});

const updatedMenu = success => ({
  type: UPDATED_MENU,
  payload: {
    updatingMenu: false,
    menuUpdated: success,
  },
});

const requestMenu = () => ({
  type: REQUEST_MENU,
  payload: {
    fetchingMenu: true,
    menuFetched: false,
  },
});

const setMenu = (menu, success) => ({
  type: SET_MENU,
  payload: {
    fetchingMenu: false,
    menuFetched: success,
    selectedMenu: menu,
  },
});

export const updateMenu = (id, changes) => {
  return dispatch => {
    dispatch(requestUpdateMenu());

    const apiRequest = UpdateMenuAPIRequest({ id: id, changes: changes });

    return callAPI(apiRequest)
      .then(json => dispatch(updatedMenu(true)))
      .catch(err => dispatch(updatedMenu(false)));
  };
};

export const updateMenuOperations = (id, changes) => {
  return dispatch => {
    dispatch(requestUpdateMenuOperations());

    const apiRequest = UpdateMenuOperationsAPIRequest({
      id: id,
      changes: changes,
    });

    return callAPI(apiRequest)
      .then(json => dispatch(updatedMenuOperations(true)))
      .catch(err => dispatch(updatedMenuOperations(false)));
  };
};

export const fetchMenu = menuID => {
  return dispatch => {
    dispatch(requestMenu());

    const apiRequest = GetMenuAPIRequest({ menu: menuID });

    return callAPI(apiRequest)
      .then(json => dispatch(setMenu(json.menu, true)))
      .catch(err => dispatch(setMenu(null, false)));
  };
};

export const fetchMenuList = () => {
  return dispatch => {
    dispatch(requestMenuList());

    const apiRequest = GetMenusAPIRequest({});

    return callAPI(apiRequest)
      .then(json => {
        dispatch(setMenuList(json, true));
      })
      .catch(err => dispatch(setMenuList([], false)));
  };
};

export const fetchOutOfStockItems = () => {
  return async dispatch => {
    dispatch(requestOutOfStock());

    const apiRequest = GetOutOfStockAPIRequest();

    try {
      const json = await callAPI(apiRequest);
      dispatch(setOutOfStockItems(json.items));
    } catch (err) {
      dispatch(setOutOfStockItemsError());
    }
  };
};

export const searchForMenuItems = query => {
  return async dispatch => {
    dispatch(requestSearchMenu());

    const apiRequest = SearchMenuItemsAPIRequest({ query });

    try {
      const json = await callAPI(apiRequest);
      dispatch(setMenuSearchResults(json.items));
    } catch (err) {
      dispatch(setMenuSearchResultsError());
    }
  };
};

export const setStockStatus = items => {
  return async dispatch => {
    dispatch(requestSetStockStatus());

    const apiRequest = SetStockStatusAPIRequest({ items });

    try {
      await callAPI(apiRequest);
      dispatch(setStockStatusUpdated());
    } catch (err) {
      dispatch(setStockStatusUpdated());
    }
  };
};



// WEBPACK FOOTER //
// ./src/actions/menus/index.js